export default __webpack_public_path__ + "static/media/bg_purple_bottom.b6531963.png";